import { atom } from 'recoil';

export const addEditMappingSetDialogState = atom({
  key: 'add-edit-mapping-set',
  default: {
    isOpen: false,
    type: 'Add',
  },
});
